import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  isChartPickerActive: false,
  isFilterActive: false,
  isTableActive: false,
  cardFeatures: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.CARD__CHART_PICKER_ACTIVATED:
      return {...state, isChartPickerActive: true, isTableActive: false};
    case AppConstants.CARD__CHART_PICKER_DEACTIVATED:
      return {...state, isChartPickerActive: false};
    case AppConstants.CARD__TABLE_ACTIVATED:
      return {...state, isChartPickerActive: false, isTableActive: true};
    case AppConstants.CARD__TABLE_DEACTIVATED:
      return {...state, isTableActive: false};
    case AppConstants.CARD__FILTER_ACTIVATED:
      return {...state, isFilterActive: true};
    case AppConstants.CARD__FILTER_DEACTIVATED:
      return {...state, isFilterActive: false};
    case AppConstants.CARD__FEATURES_LOADED: {
      const {cardId, features} = action.payload;

      return {
        ...state,
        cardFeatures: {
          ...state.cardFeatures,
          [cardId]: features,
        },
      };
    }
    case AppConstants.CARD__RESET_STATE:
      return initialState();

    case AppConstants.CARD__COPY_FILTERS_FROM_PAGE_FINISHED: {
      const {filters} = action.payload;
      return {
        ...state,
        isFilterActive: state.isFilterActive || filters.length > 0,
      };
    }

    default:
      return state;
  }
};
